import { render } from "./tpl_shop.vue?vue&type=template&id=2b7f0581&scoped=true"
import script from "./tpl_shop.vue?vue&type=script&lang=js"
export * from "./tpl_shop.vue?vue&type=script&lang=js"

import "./tpl_shop.vue?vue&type=style&index=0&id=2b7f0581&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b7f0581"],['__file',"src/views/dragger/template/tpl_shop.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2b7f0581"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2b7f0581', __exports__)) {
    console.log('reload')
    api.reload('2b7f0581', __exports__)
  }
  
  module.hot.accept("./tpl_shop.vue?vue&type=template&id=2b7f0581&scoped=true", () => {
    console.log('re-render')
    api.rerender('2b7f0581', render)
  })

}


export default __exports__